(() => {
  // One initializer across section re-renders and multiple instances.
  if (window.irayeCrossSellInitialized) return;
  window.irayeCrossSellInitialized = true;
  const init = () => document.querySelectorAll('[data-pdp-cross-sell]').forEach(box => {
    if (box.dataset.initialized) return;
    box.dataset.initialized = 'true';
    const section = box.closest('.shopify-section');
    const mainForm = section?.querySelector('form[action*="/cart/add"]');
    const sync = () => {
      const selected = mainForm?.querySelector('[name="id"]')?.value;
      const set = box.querySelector('[data-xs-set]');
      if (set) set.hidden = !selected || selected !== box.dataset.baseVariant;
    };
    mainForm?.addEventListener('change', () => { sync(); setTimeout(sync, 100); });
    // The existing variant selector changes the hidden ID attribute.
    if (mainForm) new MutationObserver(sync).observe(mainForm, {subtree:true,attributes:true,attributeFilter:['value']});
    sync();
    box.querySelectorAll('[data-xs-form]').forEach(xsForm => xsForm.addEventListener('submit', async event => {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector('button');
      if (button.disabled) return;
      button.disabled = true;
      const status = form.querySelector('[role="status"]');
      status.textContent = '';
      try {
        const root = window.Shopify?.routes?.root || '/';
        // Same endpoint, section rendering and gift initialization as product-form.js.
        const response = await fetch(root + 'cart/add.js?sections=mini-cart', {method:'POST',body:new FormData(form)});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || form.dataset.error);
        status.textContent = form.dataset.added;
        if (typeof invalidateCartCache === 'function') invalidateCartCache();
        if (typeof updateMiniCart === 'function' && data.sections?.['mini-cart']) {
          await updateMiniCart(data.sections['mini-cart']);
          if (typeof openMiniCart === 'function') openMiniCart();
          if (typeof updateCartCount === 'function') updateCartCount();
        } else {
          window.location.assign(root + 'cart');
        }
      } catch (error) {
        status.textContent = form.dataset.error;
      } finally {
        button.disabled = false;
      }
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
